
























































































































































































import Vue from "vue";
import Navbar from "../components/Navbar.vue";
import MajdaFooter from "../components/MajdaFooter.vue";

import * as parallaxHelper from "../helpers/parallax.helper";

export default Vue.extend({
  name: "Home",
  components: {
    Navbar,
    MajdaFooter,
  },
  data: function () {
    return {
      offsetY: 0,
      offsetX: 0,
    };
  },
  mounted: function () {
    parallaxHelper.hook();
  },
});
